import React from "react";

function IcapTitle() {
    return (<>
            <h1 align={'center'} style={{marginTop: '50px', padding: "1rem"}}>
                iCAP - <span className="highlight-letter">i</span>mmuno<span
                className="highlight-letter">C</span>lust <span className="highlight-letter">A</span>utomated <span
                className="highlight-letter">P</span>ipeline
            </h1>
            <h2 align={'center'} style={{marginTop: '50px', padding: "1rem"}}>
                AI-Tool for automated Clustering, Identification and Quantification of Flow Cytometry Data
            </h2>
        </>

    )
}

export default IcapTitle;